import { useNavigate } from 'react-router-dom';
import { useSetRecoilState } from 'recoil';
import { UserInfoStateRecoil } from '../utilities/globaleState';

export const useLogout = () => {
  const navigate = useNavigate();
  const setUserInfoState = useSetRecoilState(UserInfoStateRecoil);

  const logout = () => {
    // Nettoyer le localStorage
    localStorage.removeItem('token');

    // Nettoyer la sessionStorage (redirection après connexion)
    sessionStorage.removeItem('redirectAfterLogin');

    // Nettoyer l'état global
    setUserInfoState({});

    // Rediriger vers la page de connexion
    navigate('/');
  };

  return { logout };
};